/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';

// DS toggle switch (brand when on) — matches the redesigned settings look.
// Used by the Add / Edit Project modals for boolean settings.
function SwitchToggle({ checked, onChange, label, disabled }) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="flex items-center gap-3 cursor-pointer select-none">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className="relative inline-flex items-center rounded-full transition flex-shrink-0 border-0 p-0"
        style={{ width: 40, height: 22, background: checked ? '#3d5a8a' : '#c7cbd6', cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <span
          className="rounded-full bg-white"
          style={{ width: 18, height: 18, transform: checked ? 'translateX(19px)' : 'translateX(3px)', transition: 'transform .2s ease', boxShadow: '0 1px 2px rgba(14,30,64,0.25)' }}
        />
      </button>
      <span className="text-sm font-medium text-ink-900">{label}</span>
    </label>
  );
}

SwitchToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

SwitchToggle.defaultProps = { disabled: false };

export default SwitchToggle;
